import axios from 'axios';
import { IMAGE_URL } from 'constants/ApiConstant';

export const baseTableFilter = {
	page: 1,
	limit: 10,
	sortBy: 'createdAt:desc',
	// sortOrder: 'desc',
};

export const buildQueryString = (params) => {
	return Object.entries(params)
		.filter(([_, value]) => value !== undefined && value !== null && value !== '') // Keep only valid values
		.map(([key, value]) => `${key}=${encodeURIComponent(value)}`) // Encode values for URLs
		.join('&');
};

export const removeFalsyValues = (obj) => {
	return Object.fromEntries(Object.entries(obj).filter(([key, value]) => Boolean(value)));
};

export const getStatusTagColor = (status = false) => {
	if (status) {
		return 'green';
	}

	return 'volcano';
};

export const formatToCurrency = (number) => {
	const cleanedAmount = parseFloat(number.replace(/[\s,]/g, ''));
	return new Intl.NumberFormat('fr-MA', {
		style: 'currency',
		currency: 'MAD',
	}).format(cleanedAmount);
};

export const formatTextCamelCaseToNormal = (text) => {
	return text
		.replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
		.replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
		.trim(); // Clean up spaces
};

export const serverImage = (path) => {
	if (path) {
		return IMAGE_URL + path;
	}
	return null;
};

export const decodeHTMLWithRegExp = (encodedStr) => {
	// Replace HTML entities with their corresponding characters
	return encodedStr
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&amp;/g, '&')
		.replace(/&quot;/g, '"')
		.replace(/&#039;/g, "'");
};

export async function getLocationDetail(lat, lon) {
	const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
	try {
		const response = await axios.get(url);
		const data = response.data?.address;
		return data;
	} catch (error) {
		console.error('Error:', error);
		return false;
	}
}

export const mergeArrayOfObjects = (arr) => {
	return arr.reduce((merged, obj) => {
		// Loop through each key-value pair in the current object and add to the merged result
		Object.assign(merged, obj);
		return merged;
	}, {});
};


export const toUrlSlug = (title) => {
	return title
		.toLowerCase()                 // convert to lowercase
		.trim()                        // remove spaces from start/end
		.replace(/[^\w\s-]/g, '')      // remove special characters
		.replace(/\s+/g, '-')          // replace spaces with hyphen
		.replace(/-+/g, '-');          // remove multiple hyphens
}